module.exports = "<ui-view></ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/page/page.html
// module id = 588
// module chunks = 0